import { render, staticRenderFns } from "./colorSign.vue?vue&type=template&id=3dfe2a75&scoped=true"
import script from "./colorSign.vue?vue&type=script&lang=js"
export * from "./colorSign.vue?vue&type=script&lang=js"
import style0 from "./colorSign.vue?vue&type=style&index=0&id=3dfe2a75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe2a75",
  null
  
)

export default component.exports